<div class="bulk-btn">
  <button (click)="openSheet(bulkdonation, $event)" mat-button>Continue</button>
</div>

<ng-template #bulkdonation>
  <app-bulkdonation (submitted)="this.submitted.emit($event);closeSheet('bulkdonation')" [config]="config"></app-bulkdonation>
</ng-template>